import React from 'react';
import { useLocation } from 'react-router-dom';
import { customAutoLogin } from 'common-app/api/autologin/custom-autologin';
import { Spinner } from '@isyc-react/design/bootstrap';
import { ContentLayout } from 'layout';
export const CustomAutologinScene = () => {
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);
    //data
    const data = params.get('data');
    const sign = params.get('sign');
    React.useEffect(() => {
        if (data && sign) {
            customAutoLogin({ data: data, sign: sign })
                .then(res => {
                if (res.data.success) {
                    window.location.href = '/';
                }
                else {
                    setError(res.data.code);
                }
            })
                .catch((e) => {
                var _a, _b;
                setError((_b = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data.code) !== null && _b !== void 0 ? _b : e.message);
            })
                .finally(() => setLoading(false));
        }
        else {
            setError('Aucune donnée ou signature fournie');
        }
    }, [data, sign]);
    return (React.createElement(ContentLayout, null,
        loading && React.createElement(Spinner, { animation: 'border', className: 'ms-2', size: 'sm' }), error !== null && error !== void 0 ? error : ''));
};
